import { useState } from "react";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { getUserProfile } from "../../service/userservice/getUserProfile";
import FormInputError from "../General/FormInputError";
import DomainErrorModal from "../ModalDialogs/DomainErrorModal";
import { sha384 } from "crypto-hash";
import { Trans, useTranslation } from "react-i18next";

import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const PanelTwo = ({
  customerRegistrationFormData,
  setCustomerRegistrationFormData,
  setCurrentStep,
  setLoading,
}) => {
  const uuid = uuidv4();
  const { t } = useTranslation();
  const [errorInfo, seterrorInfo] = useState("");
  const [modalState, setModalState] = useState(false);
  const [openEyePassword, setOpenEyePassword] = useState(true);
  const [openEyeConfirmPassword, setOpenEyeConfirmPassword] = useState(true);

  const {
    register: registrationPanelTwoRegister,
    getValues,
    handleSubmit,
    formState: { errors: registrationPanelTwoErrors },
  } = useForm({
    defaultValues: customerRegistrationFormData,
  });

  const togglePasswordEye = () => {
    setOpenEyePassword(!openEyePassword);
  };

  const toggleConfirmPasswordEye = () => {
    setOpenEyeConfirmPassword(!openEyeConfirmPassword);
  };

  async function onSubmit(data) {
    setLoading(true);
    let userProfile = await getUserProfile(data.username).catch((error) => {
      console.log(error);
    });

    setLoading(false);

    if (userProfile === null) {
      let hashedPassword = (await sha384(data.password))
        .toString()
        .substring(15, 30);
      data.hashedPassword = hashedPassword;
      setCustomerRegistrationFormData((curr) => ({ ...curr, ...data }));
      setCurrentStep(3);
    } else {
      seterrorInfo(t("CustomerRegister-step-2-form-error-1"));
      setModalState(true);
    }
  }

  return (
    <>
      <form
        className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-medium"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div>
          <label id={`${uuid}-usernameLabel`}>
            {t("CustomerRegister-step-2-form-label-1")}
          </label>
          <input
            id={`${uuid}-username`}
            className="w-full"
            type="text"
            placeholder="Username"
            {...registrationPanelTwoRegister("username", {
              required: t("CustomerRegister-step-2-form-error-2"),
              validate: {
                minimumCharCount: (v) =>
                  v.length >= 10 || t("CustomerRegister-step-2-form-error-3"),
                maximumCharCount: (v) =>
                  v.length <= 50 || t("CustomerRegister-step-2-form-error-4"),
                illegalLetter: (v) =>
                  v.replace(/[A-Za-z0-9\.\-\_]/g, "").length < 1 ||
                  t("CustomerRegister-step-2-form-error-5"),
              },
            })}
            aria-labelledby={`${uuid}-usernameLabel`}
          />

          {registrationPanelTwoErrors.username && (
            <FormInputError
              id={`${uuid}-usernameError`}
              errorMessage={registrationPanelTwoErrors.username.message}
            />
          )}
        </div>

        <div className="mt-4 text-sm">
          <div className="font-semibold">
            {t("CustomerRegister-step-2-form-label-2")}
          </div>
          <ul className="list-disc ml-4">
            <li>{t("CustomerRegister-step-2-form-label-3")}</li>
            <li>{t("CustomerRegister-step-2-form-label-4")}</li>
          </ul>
        </div>

        <div className="mt-4 relative">
          <label id={`${uuid}-passwordLabel`}>
            {t("CustomerRegister-step-2-form-label-7")}
          </label>
          <input
            id={`${uuid}-password`}
            className="w-full"
            autoComplete="off"
            type={openEyePassword ? "password" : "text"}
            placeholder="Password"
            {...registrationPanelTwoRegister("password", {
              required: t("CustomerRegister-step-2-form-error-6"),
              validate: {
                charLimit: (v) =>
                  (v.length >= 10 && v.length <= 61) ||
                  t("CustomerRegister-step-2-form-error-7"),
                hasLowerCaseLetter: (v) =>
                  /^(?=.*[a-z])/.test(v) ||
                  t("CustomerRegister-step-2-form-error-8"),
                hasCapitalizedCaseLetter: (v) =>
                  /^(?=.*[A-Z])/.test(v) ||
                  t("CustomerRegister-step-2-form-error-9"),
                hasNumericLetter: (v) =>
                  /^(?=.*[0-9])/.test(v) ||
                  t("CustomerRegister-step-2-form-error-10"),
                allowedSpecialChars: (v) =>
                  /^(?=.*[!@#\$%&\*\(\)])/.test(v) ||
                  t("CustomerRegister-step-2-form-error-11"),
                illegalLetter: (v) =>
                  v.replace(/[A-Za-z0-9!@#\$%&\*\(\)]/g, "").length < 1 ||
                  t("CustomerRegister-step-2-form-error-12"),
              },
            })}
            aria-labelledby={`${uuid}-passwordLabel`}
          />
          <div className="absolute top-8 right-4">
            {openEyePassword ? (
              <AiOutlineEye onClick={togglePasswordEye}></AiOutlineEye>
            ) : (
              <AiOutlineEyeInvisible
                onClick={togglePasswordEye}
              ></AiOutlineEyeInvisible>
            )}
          </div>
          {registrationPanelTwoErrors.password && (
            <FormInputError
              id={`${uuid}-passwordError`}
              errorMessage={registrationPanelTwoErrors.password.message}
            />
          )}
        </div>
        <div className="mt-4 text-sm">
          <div className="font-semibold">
            {t("CustomerRegister-step-2-form-password-label-1")}
          </div>
          <ul className="list-disc ml-4">
            <li>{t("CustomerRegister-step-2-form-password-label-2")}</li>
            <li>{t("CustomerRegister-step-2-form-password-label-3")}</li>
            <li>{t("CustomerRegister-step-2-form-password-label-4")}</li>
            <li>{t("CustomerRegister-step-2-form-password-label-5")}</li>
          </ul>
        </div>

        <div className="mt-4 relative">
          <label id={`${uuid}-confirmPasswordLabel`}>
            {t("CustomerRegister-step-2-form-label-11")}
          </label>
          <input
            id={`${uuid}-confirmPassword`}
            className="w-full"
            type={openEyeConfirmPassword ? "password" : "text"}
            autoComplete="off"
            placeholder="Password"
            {...registrationPanelTwoRegister("confirmPassword", {
              required: t("CustomerRegister-step-2-form-error-13"),
              validate: (value) => {
                if (getValues("password") !== value)
                  return t("CustomerRegister-step-2-form-error-14");
              },
            })}
            aria-labelledby={`${uuid}-confirmPasswordLabel`}
          />
          <div className="absolute top-8 right-4">
            {openEyeConfirmPassword ? (
              <AiOutlineEye onClick={toggleConfirmPasswordEye}></AiOutlineEye>
            ) : (
              <AiOutlineEyeInvisible
                onClick={toggleConfirmPasswordEye}
              ></AiOutlineEyeInvisible>
            )}
          </div>
          {registrationPanelTwoErrors.confirmPassword && (
            <FormInputError
              id={`${uuid}-confirmPasswordError`}
              errorMessage={registrationPanelTwoErrors.confirmPassword.message}
            />
          )}
        </div>

        <div className="mt-4">
          <label id={`${uuid}-emailLabel`}>
            {t("CustomerRegister-step-2-form-label-12")}
          </label>
          <input
            disabled={customerRegistrationFormData.email !== "" ? true : false}
            id={`${uuid}-email`}
            className="w-full"
            type="text"
            placeholder="Email Address"
            {...registrationPanelTwoRegister("email", {
              required: t("CustomerRegister-step-2-form-error-15"),
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: t("CustomerRegister-step-2-form-error-16"),
              },
            })}
            aria-labelledby={`${uuid}-emailLabel`}
          />

          {registrationPanelTwoErrors.email && (
            <FormInputError
              id={`${uuid}-emailError`}
              errorMessage={registrationPanelTwoErrors.email.message}
            />
          )}
        </div>

        <div className="mt-4">
          <label id={`${uuid}-confirmEmailLabel`}>
            {t("CustomerRegister-step-2-form-label-13")}
          </label>
          <input
            disabled={customerRegistrationFormData.email !== "" ? true : false}
            id={`${uuid}-confirmEmail`}
            className="w-full"
            type="text"
            placeholder="Email Address"
            {...registrationPanelTwoRegister("confirmEmail", {
              required: t("CustomerRegister-step-2-form-error-17"),
              validate: (value) => {
                if (getValues("email") !== value)
                  return t("CustomerRegister-step-2-form-error-18");
              },
            })}
            aria-labelledby={`${uuid}-confirmEmailLabel`}
          />

          {registrationPanelTwoErrors.confirmEmail && (
            <FormInputError
              id={`${uuid}-confirmEmailError`}
              errorMessage={registrationPanelTwoErrors.confirmEmail.message}
            />
          )}
        </div>

        <div className="mt-4 text-right">
          <button
            className="ui-btn-secondary ui-btn-min-w mt-2"
            type="button"
            onClick={() => setCurrentStep(1)}
          >
            <Trans
              i18nKey="CustomerRegister-step-2-form-button-1"
              components={{
                srText: <span className="sr-only"></span>,
              }}
            ></Trans>
          </button>
          <button className="ui-btn-primary ui-btn-min-w mt-2" type="submit">
            <Trans
              i18nKey="CustomerRegister-step-2-form-button-2"
              components={{
                srText: <span className="sr-only"></span>,
              }}
            ></Trans>
          </button>
        </div>
      </form>
      <DomainErrorModal
        modalState={modalState}
        setModalState={setModalState}
        errorInfo={errorInfo}
      />
    </>
  );
};

export default PanelTwo;
